import { render } from "./BirthPlace.vue?vue&type=template&id=099109c2&scoped=true"
import script from "./BirthPlace.vue?vue&type=script&lang=js"
export * from "./BirthPlace.vue?vue&type=script&lang=js"

import "./BirthPlace.vue?vue&type=style&index=0&id=099109c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099109c2"]])

export default __exports__